import { FC } from 'react'
import { FilterSection } from '@/network/graphql.g'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  motives: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterMotivesSlidePage: FC<Props> = ({
  motives,
  initialSelections,
  updatePendingFilter
}) => {
  const items: MobileFilterItemType[] =
    motives?.flatMap((s) =>
      s.items.map((i) => ({
        id: i.id,
        title: i.title,
        count: i.count
      }))
    ) ?? []

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
    />
  )
}
export default FilterMotivesSlidePage
